import { EnumLanguage } from '@libs/constants';


/**------------------------------------------------------
 * Data Structure
 */
export interface IProcessedKeywords {
	keywords		: string[][];
	formattedText 	: string;
}

export interface IModelData {
	processing: IProcessing;
}

export interface IProcessing {
	processedKeywords: IInputKeywords;
	processingOptions: IProcessingOptions;
}

export interface IInputKeywords {
	originalText	: string;
	formattedText 	: string;
}


/**------------------------------------------------------
 * Processing Options
 */
export interface IProcessingOptions {
	actions			: IActionOptions;
	textFormat		: EnumTextFormat;
	sorting			: ISortingOptions;
	group			: EnumGroup;
	outputFormat	: IOutputFormatOptions;
}


/**------------------------------------------------------
 * Action Options
 */
export interface IActionOptions {
	extractKeywords		: {
		active			: boolean;
		language		: EnumLanguage;
	};
	removeDuplicates	: boolean;
	removeContaining	: {
		active			: boolean;
		text			: string;
	};
	removeCommonWords	: {
		active			: boolean;
		language		: EnumLanguage;
	};
	removeUnwantedWords	: boolean;
	removeNumbers		: boolean;
	removeSingleLetters	: boolean;
	removeAsin			: boolean;
	removeSpecialChar	: {
		active			: boolean;
		exclude			: string;
	};
	replace				: {
		active			: boolean;
		oldText			: string;
		newText			: string;
	};
	combineWordsBy		: {
		active			: boolean;
		combineBy		: string;
	};
	increaseNumberBy	: {
		active			: boolean;
		increaseBy		: number | null;
	};
}


/**------------------------------------------------------
 * Text Format Options
 */
export enum EnumTextFormat {
	KeepOriginal	= 'keep_original',
	TitleCase		= 'title_case',
	UpperCase		= 'upper_case',
	LowerCase		= 'lower_case'
}


/**------------------------------------------------------
 * Output Format Options
 */
export interface IOutputFormatOptions {
	format			: EnumOutputFormat;
	customSeparator	: string;
}

export enum EnumOutputFormat {
	CommaWithSpace	= 'comma_with_space',
	OnlySpace		= 'only_space',
	SeparateBy		= 'separate_by',
	OnePerLine 		= 'one_per_line'
}


/**------------------------------------------------------
 * Group Options
 */
export enum EnumGroup {
	NoGrouping		= 'no_grouping',
	SingleAndPhrase	= 'single_and_phrase',			// dividing single and long-song tail keywords
	WordCount		= 'word_count'
}


/**------------------------------------------------------
 * Sorting Options
 */
export interface ISortingOptions {
	sorting			: EnumSorting;
	sortingDirection: EnumSortingDirection;
}

export enum EnumSorting {
	KeepOriginal	= 'keep_original',
	Alphabetic		= 'alphabetic',
	Occurrence		= 'occurrence',
	CharacterLength	= 'character_length',
	RandomShuffle	= 'random_shuffle'
}

export enum EnumSortingDirection {
	Ascending		= 'ascending',
	Descending		= 'descending'
}
